const state = {
    abilities: [],
};

const mutations = {
    setAbilities(state, value) {
        state.abilities = value;
    },
};

const actions = {};

const getters = {
    abilities: (state) => state.abilities,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
